<template>
  <div class="upload-button-content">
    <el-button v-if="roundFlag" type="primary" id="uploadButton" :size="size" round @click="triggerFileSelect">
      上传<i class="el-icon-upload el-icon--right" />
    </el-button>
    <el-button v-if="circleFlag" size="size" id="uploadButton" circle>
      <i class="el-icon-upload" />
    </el-button>
    <input type="file" ref="fileInput" @change="handleFileSelect" multiple class="visually-hidden" />
  </div>
</template>

<script>
import Uploader from "simple-uploader.js";
import { getToken } from "../../../utils/cookie";
import panUtil from "../../../utils/common";
import { MD5 } from "../../md5";
import fileService from "../../../api/file";
import { mapActions, mapGetters, mapMutations } from "vuex";
import OSS from "ali-oss";

export default {
  name: "uploadButton",
  components: {},
  props: {
    roundFlag: Boolean,
    circleFlag: Boolean,
    size: String,
  },
  data() {
    return {
      uploadUrl: panUtil.getUrlPrefix() + "/resources/uploadFile",
      uploadHeaders: {
        Accesstoken: getToken(),
      },
      uploadDialogVisible: false,
    };
  },
  mounted() {
    // this.client = new OSS({
    //   // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    //   region: "oss-cn-beijing",
    //   authorizationV4: true,
    //   // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    //   accessKeyId: "STS.NWtursdruMY2ExoBr82e9dAG5",
    //   accessKeySecret: "E9zPysJtTGLy41173zdKZG1Lcn8gJ6Vs8zKvLoMqTsnM",
    //   // 从STS服务获取的安全令牌（SecurityToken）。
    //   stsToken:
    //     "CAISxAJ1q6Ft5B2yfSjIr5TBPsjHia1U+pvZR17epnJtPuoVi4Ts1zz2IHhMfXJqB+odvvwwn2pS6fcflrpiTIJff0vAYPB99Y9W9gWHao/M43MYK3aO0s/LI3OaLjKm9u2wCryLYbGwU/OpbE++5U0X6LDmdDKkckW4OJmS8/BOZcgWWQ/KBlgvRq0hRG1YpdQdKGHaONu0LxfumRCwNkdzvRdmgm4NgsbWgO/ks0aE0QSrmrNJ+92tcsL5NPMBZskvD42Hu8VtbbfE3SJq7BxHybx7lqQs+02c5onEWAMPuU7Wa7WPqIcwfVJjCLIzHqlft+gJEWjnDwJ//W6e6mGuXYk9O0y3LOgrEF1OogmGGPwN1KcpGrU84yGet6OPxycOS1x1mm2k1VTPVPH+d7KCtM+0pM3D2hT+Bi3HLQztFtBWr8cdpz0agAGOoKc3R9T4o42h1589xOCKK8wQvpiF1LQ/PRGxOWQsUnNDOiH7DXqg0aAw8XibY/OeNylaPRVF4yZCumsHzlt5W4aow9LmeQo1G5nQt9qu81XPCCMjQ69WS2IiAc6ylvt5T+atHi8INIhbqhei7X/vEXxOHL0lT2KO5O30HQRZVyAA",
    //   // 填写Bucket名称，例如examplebucket。
    //   bucket: "panresource",
    // });
  },
  computed: {
    ...mapGetters(["active", "usedMemory", "memoryCapacity", "parentId"]),
  },
  methods: {
    ...mapMutations({
      clearTaskList: "task/clear",
      addTaskItem: "task/add",
      removeTaskItem: "task/remove",
      updateTaskStatus: "task/updateStatus",
      updateTaskProcess: "task/updateProcess",
      getUploadTask: "task/getTask",
      updateTaskListViewFlag: "task/updateViewFlag",
    }),
    ...mapActions({
      reloadFileList: "file/loadFileList",
    }),
    //文件选择
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    //文件选择回调
    handleFileSelect(event) {
      const _this = this;
      const input = event.target;
      _this.updateTaskListViewFlag(true);

      let currentDate = new Date();
      const dirName =
        "resource/" +
        currentDate.getFullYear() +
        "/" +
        Number(currentDate.getMonth() + 1)
          .toString()
          .padStart(2, "0") +
        "/" +
        currentDate
          .getDate()
          .toString()
          .padStart(2, "0") +
        "/";

      for (let index = 0; index < input.files.length; index++) {
        const suffix = input.files[index].name.split(".")[
          input.files[index].name.split(".").length - 1
        ];
        const ossPath = dirName + this.uuid() + "." + suffix;

        let taskItem = {
          target: input.files[index],
          fileName: input.files[index].name,
          fileSize: input.files[index].size,
          ossPath: ossPath,
          uploadedSize: 0,
          status: panUtil.fileStatus.PARSING.code,
          statusText: panUtil.fileStatus.PARSING.text,
          timeRemaining: 0,
          speed: 0,
          percentage: 0,
          parentId: new String(_this.parentId),
        };
        // 添加
        _this.addTaskItem(taskItem);

        MD5(input.files[index], (e, md5) => {
          fileService.secUpload(
            {
              md5Code: md5,
              ossPath: ossPath,
              orignName: input.files[index].name,
              resourceMemory: input.files[index].size,
            },
            (res) => {
              //
              if (!res.data.checked) {
                // 新文件
                const client = new OSS({
                  // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                  region: "oss-cn-beijing",
                  authorizationV4: true,
                  // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                  accessKeyId: res.data.stsToken.accessKeyId,
                  accessKeySecret: res.data.stsToken.accessKeySecret,
                  // 从STS服务获取的安全令牌（SecurityToken）。
                  stsToken: res.data.stsToken.securityToken,
                  // 填写Bucket名称，例如examplebucket。
                  bucket: "panresource",
                });
                client.multipartUpload(ossPath, input.files[index], {
                  // 获取分片上传进度、断点和返回值。
                  progress: (p, cpt, res2) => {
                    // progressDiv.innerHTML = p;
                    if (p == 1) {
                      // 上传完成
                      this.updateTaskStatus({
                        fileName: input.files[index].name,
                        status: panUtil.fileStatus.MERGE.code,
                        statusText: panUtil.fileStatus.MERGE.text,
                      });
                      this.updateTaskProcess({
                        fileName: input.files[index].name,
                        // speed: panUtil.translateSpeed(file.averageSpeed),
                        percentage: 100,
                        uploadedSize: input.files[index].size,
                        timeRemaining: 0,
                      });

                      fileService.createFolder(
                        {
                          fileName: input.files[index].name, //文件名
                          fileType: "FILE", //文件类型 FILE,DIR
                          resourceFlowNo: res.data.data.flowNo, //资源主键
                          parentFlowNo: _this.parentId, //父级目录主键
                        },
                        () => {
                          this.updateTaskStatus({
                            fileName: input.files[index].name,
                            status: panUtil.fileStatus.SUCCESS.code,
                            statusText: panUtil.fileStatus.SUCCESS.text,
                          });
                          this.updateTaskProcess({
                            fileName: input.files[index].name,
                            // speed: panUtil.translateSpeed(file.averageSpeed),
                            percentage: 100,
                            uploadedSize: input.files[index].size,
                            timeRemaining: 0,
                          });
                        },
                        (err) => {
                          this.updateTaskStatus({
                            fileName: file.name,
                            status: panUtil.fileStatus.FAIL.code,
                            statusText: panUtil.fileStatus.FAIL.text,
                          });
                        }
                      );
                    } else {
                      // 更新状态
                      this.updateTaskProcess({
                        fileName: input.files[index].name,
                        // speed: panUtil.translateSpeed(file.averageSpeed),
                        percentage: Math.floor(p * 100),
                        uploadedSize: Number(p * cpt.fileSize),
                        timeRemaining: 0,
                        abortCheckpoint: cpt,
                      });
                    }
                  },
                  // 设置并发上传的分片数量。
                  parallel: 4,
                  // 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
                  partSize: 1024 * 1024,
                  // headers,
                  // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
                  meta: { year: 2020, people: "test" },
                  mime: "text/plain",
                  // 设置上传回调。
                  // 如果不涉及回调服务器，请删除callback相关设置。
                  // callback: {
                  //   // 设置回调请求的服务器地址。
                  //   url: "http://examplebucket.aliyuncs.com:23450",
                  //   // 设置回调请求消息头中Host的值，即您的服务器配置Host的值。
                  //   host: "yourHost",
                  //   /* eslint no-template-curly-in-string: [0] */
                  //   // 设置发起回调时请求body的值。
                  //   body: "bucket=${bucket}&object=${object}&var1=${x:var1}",
                  //   // 设置发起回调请求的Content-Type。
                  //   contentType: "application/x-www-form-urlencoded",
                  //   customValue: {
                  //     // 设置发起回调请求的自定义参数。
                  //     var1: "value1",
                  //     var2: "value2",
                  //   },
                  // },
                });
                this.updateTaskStatus({
                  fileName: input.files[index].name,
                  status: panUtil.fileStatus.UPLOADING.code,
                  statusText: panUtil.fileStatus.UPLOADING.text,
                  client: client,
                });
              } else {
                // 已有文件，直接上传
                this.updateTaskStatus({
                  fileName: input.files[index].name,
                  status: panUtil.fileStatus.MERGE.code,
                  statusText: panUtil.fileStatus.MERGE.text,
                });
                fileService.createFolder(
                  {
                    fileName: res.data.data.orignName, //文件名
                    fileType: "FILE", //文件类型 FILE,DIR
                    resourceFlowNo: res.data.data.flowNo, //资源主键
                    parentFlowNo: _this.parentId, //父级目录主键
                  },
                  () => {
                    this.updateTaskStatus({
                      fileName: input.files[index].name,
                      status: panUtil.fileStatus.SUCCESS.code,
                      statusText: panUtil.fileStatus.SUCCESS.text,
                    });
                    this.updateTaskProcess({
                      fileName: input.files[index].name,
                      // speed: panUtil.translateSpeed(file.averageSpeed),
                      percentage: 100,
                      uploadedSize: input.files[index].size,
                      timeRemaining: 0,
                    });
                  },
                  (err) => {
                    console.log("err", err);
                    this.updateTaskStatus({
                      fileName: input.files[index].name,
                      status: panUtil.fileStatus.FAIL.code,
                      statusText: panUtil.fileStatus.FAIL.text,
                    });
                  }
                );
              }
            },
            (err) => {
              console.log("err", err);
              _this.removeTaskItem(input.files[index].name);
            }
          );
        });
      }
    },
    uuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
  },
};
</script>

<style>
.upload-button-content {
  display: inline-block;
  margin-right: 10px;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
